import {
  Autocomplete,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { getPlacesForText } from "../../../services/rest/mapbox/getPlaces";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import { navigation } from "../../../services/rest/mapbox/navigationMap";
import useLocation from "../../../hooks/useLocation";
import { useDispatch } from "react-redux";
import {
  setCoordinates,
  setDataRoute,
  setLandMarks,
} from "../../../redux/slice/routeSlice";

const InputDrawRoute = ({ setLoading }) => {
  const { location } = useLocation();
  const [optionsPlaces, setOptionsPlaces] = useState([]);
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch();

  const getPlaces = async (text) => {
    try {
      if (text === "") {
        return;
      }
      const response = await getPlacesForText({ text });
      setOptionsPlaces(response ?? []);
    } catch (error) {
      throw error;
    }
  };

  const handleSearch = async (text) => {
    try {
      // console.log("Texto a buscar", text);
      setSearchText(text);
      await getPlaces(text);
    } catch (error) {
      toast.error("No se encontraron resultados. \nIntentalo más tarde.");
    }
  };

  const onPressPlace = async (place) => {
    try {
      setLoading(true);
      // console.log("Ubicación seleccionada", location);

      const coordinates = [
        [location?.longitude, location?.latitude],
        place?.geometry?.coordinates,
      ];
      // console.log("Coordenadas", coordinates);
      const coordinatesString = coordinates
        .map((coord) => coord.join(","))
        .join(";");

      const route = await navigation(coordinatesString);
      // console.log("Ruta", route);
      dispatch(
        setCoordinates({ coordinates: route?.geometry?.coordinates ?? [] })
      );
      dispatch(setLandMarks({ landMarks: coordinates }));
      dispatch(
        setDataRoute({
          distance: route?.distance ?? 0,
          estimatedTime: route?.duration ?? "0 min",
        })
      );

      setOptionsPlaces([]);
      setLoading(false);
    } catch (error) {
      setOptionsPlaces([]);
      setLoading(false);
      toast.error("No se encontraron resultados. \nIntentalo más tarde.");
    }
  };

  return (
    <Box>
      <TextField
        label="Inicio de la Ruta"
        name="initRoute"
        variant="filled"
        style={{
          backgroundColor: "black",
          borderRadius: 5,
          width: "100%",
        }}
        onChange={(e) => handleSearch(e.target.value)}
      />
      <Box sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
        {optionsPlaces.length > 0 &&
          optionsPlaces.map(
            (place, key) =>
              place?.properties?.full_address && (
                <List key={key}>
                  <ListItem>
                    <ListItemButton onClick={() => onPressPlace(place)}>
                      <ListItemIcon>
                        <FmdGoodIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={`${place?.properties?.full_address}`}
                      />
                    </ListItemButton>
                  </ListItem>
                </List>
              )
          )}
      </Box>
    </Box>
  );
};

export default InputDrawRoute;
